import React from 'react';

import styles from './GraphBar.module.css';

interface GraphBarProps {
  value: number;
  max: number;
  label: string;
}

const GraphBar = (props: GraphBarProps) => {

  const calculateHeight = () => {
    return props.value / props.max * 150;
  }

  return (
    <div className={styles.graphBar}>
      <div className={styles.tooltip}>
        {`$${props.value}`}
      </div>
      <div
        className={`${styles.bar} ${((props.value >= props.max) && styles.max) || ''}`}
        style={{ height: calculateHeight() }}
      />
      <p className={styles.label}>{props.label}</p>
    </div>
  );
}

export default GraphBar;